var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronUpV2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 9,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.695 8.01L6.978 3.322 2.26 8.01.81 6.566 6.979.425l6.166 6.141-1.45 1.444z",
    fill: "#036"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSI5IiB2aWV3Qm94PSIwIDAgMTQgOSIgZmlsbD0ibm9uZSI+CjxwYXRoIGQ9Ik0xMS42OTQ3IDguMDA5NzFMNi45Nzc2NCAzLjMyMTcyTDIuMjYwNTYgOC4wMDk3MUwwLjgxMTUyMyA2LjU2NjQ2TDYuOTc3NjQgMC40MjQ5OTRMMTMuMTQzOCA2LjU2NjQ2TDExLjY5NDcgOC4wMDk3MVoiIGZpbGw9IiMwMDMzNjYiLz4KPC9zdmc+";
export { SvgChevronUpV2 as ReactComponent };